import React from 'react';
import Posts from './Posts';

export default function Root() {
  return (
    <div className='container mx-auto'>
      <Posts />
    </div>
  );
}
